import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const InvoiceTemplateService = {};

InvoiceTemplateService.listInvoiceTemplate = ({ params }, bu_code) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/invoice-templates`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      bu_code,
    },
  });
};

InvoiceTemplateService.listInvoiceType = (businessUnitId, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/business-units/list-invoice-type/${businessUnitId}`,
    method: "get",
    params: {
      bu_code,
    },
  });
};

InvoiceTemplateService.createInvoiceTemplate = (data, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-templates`,
    method: "post",
    data: {
      ...data,
      bu_code
    },
  });
};

InvoiceTemplateService.getDetailInvoiceTemplate = id => {
  return fetch({
    url: `${env.API_MSP}/invoice-templates/${id}`,
    method: "get",
  });
};

InvoiceTemplateService.updateInvoiceTemplate = ({ id, data }) => {
  return fetch({
    url: `${env.API_MSP}/invoice-templates/${id}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

InvoiceTemplateService.deleteInvoiceTemplate = id => {
  return fetch({
    url: `${env.API_MSP}/invoice-templates/${id}`,
    method: "delete",
  });
};

InvoiceTemplateService.uploadImage = (formData) => {
  return fetch({
    url: `${env.API_MSP}/resource-global/upload-file`,
    method: "post",
    data: formData,
  });
};

export default InvoiceTemplateService;
